import React from 'react'
import styled from 'styled-components'

const FeaturedSVG = styled.svg`
  width: 104px;
  height: 24px;
  g {
    fill: ${(props) => props.theme.colors.inverseColor};
  }
`

const FeaturedBanner = () => (
  <>
    <FeaturedSVG>
      <defs>
        <linearGradient id='b' x1='50%' x2='50%' y1='0%' y2='100%'>
          <stop offset='0%' stopColor='#FFF' stopOpacity='.5' />
          <stop offset='100%' stopOpacity='.5' />
        </linearGradient>
        <path id='a' d='M0 0h104l-8 12 8 12H0z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <mask id='c' fill='#fff'>
          <use xlinkHref='#a' />
        </mask>
        <use fill='#D8D8D8' xlinkHref='#a' />
        <use fill='url(#b)' xlinkHref='#a' />
        <g mask='url(#c)'>
          <path id='a' d='M0 0h104l-8 12 8 12H0z' />
        </g>
        <path
          fill='#FFF'
          d='M16.124
          17V6.328h6.992v1.184h-5.664v3.44h5.552v1.184h-5.552V17h-1.328zm8.304-3.872c0-2.24
          1.6-4.048 3.808-4.048 2.336 0 3.712 1.824 3.712 4.144v.304h-6.256c.096 1.456 1.12 2.672
          2.784 2.672.88 0 1.776-.352 2.384-.976l.576.784c-.768.768-1.808 1.184-3.072 1.184-2.288
          0-3.936-1.648-3.936-4.064zm3.792-3.056c-1.648
          0-2.464 1.392-2.528 2.576h5.072c-.016-1.152-.784-2.576-2.544-2.576zM38.716
          17v-.88c-.64.704-1.52 1.072-2.56 1.072-1.312 0-2.704-.88-2.704-2.56 0-1.728
          1.392-2.544 2.704-2.544 1.056 0 1.936.336 2.56
          1.056v-1.392c0-1.04-.832-1.632-1.952-1.632-.928 0-1.68.336-2.368
          1.072l-.56-.832c.832-.864 1.824-1.28 3.088-1.28 1.632 0 2.992.736
          2.992 2.608V17h-1.2zm0-1.632v-1.456c-.464-.64-1.28-.96-2.128-.96-1.12
          0-1.904.704-1.904 1.696 0 .976.784 1.68 1.904 1.68.848 0 1.664-.32
          2.128-.96zm5.552
          1.824c-1.136 0-1.712-.656-1.712-1.808v-5.056h-1.28V9.272h1.28V7.16h1.2v2.112h1.568v1.056h-1.568v4.8c0
          .576.256.992.784.992.336 0 .656-.144.816-.32l.352.896c-.304.288-.736.496-1.44.496zM52.236
          17v-1.088c-.592.672-1.6 1.28-2.752 1.28-1.616 0-2.464-.784-2.464-2.464V9.272h1.2v5.088c0
          1.36.688 1.76 1.728 1.76.944 0
          1.84-.544 2.288-1.168v-5.68h1.2V17h-1.2zm3.6
          0V9.272h1.2v1.248c.624-.816 1.52-1.408 2.576-1.408v1.232a2.115 2.115
          0 0 0-.48-.048c-.736 0-1.744.608-2.096 1.232V17h-1.2zm4.832-3.872c0-2.24
          1.6-4.048 3.808-4.048 2.336 0 3.712 1.824 3.712 4.144v.304h-6.256c.096
          1.456 1.12 2.672 2.784 2.672.88 0
          1.776-.352 2.384-.976l.576.784c-.768.768-1.808
          1.184-3.072 1.184-2.288 0-3.936-1.648-3.936-4.064zm3.792-3.056c-1.648
          0-2.464 1.392-2.528 2.576h5.072c-.016-1.152-.784-2.576-2.544-2.576zM75.724
          17v-1.152c-.576.784-1.52 1.344-2.608 1.344-2.016 0-3.44-1.536-3.44-4.048
          0-2.464 1.408-4.064 3.44-4.064 1.04 0 1.984.512
          2.608 1.36V6.328h1.2V17h-1.2zm0-2.096V11.4c-.432-.672-1.36-1.248-2.32-1.248-1.552
          0-2.48 1.28-2.48 2.992s.928 2.976 2.48 2.976c.96 0 1.888-.544 2.32-1.216z'
          mask='url(#c)'
        />
      </g>
    </FeaturedSVG>
  </>
)

export default FeaturedBanner
